import { CONSTANTS } from '@shared/constants';

const NON_RESUMABLE_SEGMENTS: readonly string[] = [
  CONSTANTS.ROUTES.LOGIN,
  CONSTANTS.ROUTES.NO_ACCESS,
  CONSTANTS.ROUTES.NOT_FOUND,
];

/**
 * Whether a URL is somewhere a user can be sent back to once authenticated.
 *
 * The auth landing pages are not: storing one as `lastUrl` or passing one as a
 * `redirectUrl` query param makes a successful login navigate straight back to
 * the login screen.
 */
export function isResumableUrl(url: string | null | undefined): boolean {
  const path = url?.trim().split(/[?#]/)[0];

  if (!path || path === '/') {
    return false;
  }

  return !path
    .split('/')
    .filter(Boolean)
    .some(segment => NON_RESUMABLE_SEGMENTS.includes(segment));
}
